import React from 'react';
import { usePrototype } from '../../contexts/PrototypeContext';
interface FramePlaceholderBoundaryProps {
  /** Name of the preview component, e.g. "WfCartFramePreview". */
  frame: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * Marks the region where a NATIVE Website Forge frame output will render.
 * Everything inside is a visual placeholder. At integration, replace the children
 * with the existing native frame reference and keep only the scoped wrapper styling.
 * The dashed outline + label appear only when "Frame boundaries" is on in the review tool.
 */
export function FramePlaceholderBoundary({
  frame,
  className = '',
  children
}: FramePlaceholderBoundaryProps) {
  const {
    showFrameBounds
  } = usePrototype();
  return <div data-wf-frame-placeholder={frame} className={`relative ${showFrameBounds ? 'outline-dashed outline-2 outline-offset-[10px] outline-bronze' : ''} ${className}`} data-id="element-25" data-mp="136kdhymj75lz">
      {showFrameBounds && <span data-prototype-only className="absolute -top-9 left-0 z-10 rounded-[3px] bg-bronze-deep px-2 py-1 text-[11px] font-medium text-canvas" data-id="element-26" data-mp="7lecxin7empu">
          Native WF frame placeholder · {frame}
        </span>}
      {children}
    </div>;
}